import axios from 'axios';

export default async function getAllAdminsAndOperators({
  accessToken,
  query,
  setTokenLikeExpired,
}) {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_AUTH_API_URL}/get-admins-and-operators?query=${query}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  }
}
